export const usePageStore = defineStore("page", () => {
  const alternateLanguages = ref<{ id: string; lang: string; type: string }[]>([]);

  const isHeroActive = ref(true);
  return { alternateLanguages, isHeroActive };
});
